import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M6 21v-2a4 4 0 0 1 4 -4h4" }),
		/* @__PURE__ */ _jsx("path", { d: "M15 19l2 2l4 -4" })
	]
});
export { SvgUserCheck as ReactComponent };
